import type { track as TrackType } from "pro-features/components/WithTrack/src/context";
import { allTrackers } from "app/services/track/track";

export type QueryBarFilterTrackingEntity = {
    trackToggleFilter(): void;
    trackFilterItemClick(id: string): void;
    trackCreateActivationSetCtaClick(): void;
};

const createQueryBarFilterTracking = (track: TrackType): QueryBarFilterTrackingEntity => ({
    trackToggleFilter() {
        track("Drop Down", "open", "Projects/Open Project");
    },
    trackFilterItemClick(id: string) {
        track("Button", "submit-ok", `Projects/Apply Project/${id}`);
    },
    trackCreateActivationSetCtaClick() {
        track("Button", "submit-ok", "Projects/Create Project");
    },
});

export default createQueryBarFilterTracking(allTrackers.dispatchTrackEvent.bind(allTrackers));
